import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconAvatar from 'Views/Onboarding/Components/IconAvatar';

const styles = theme => ({
  root: {},
  img: {
    filter: theme.filters.primaryBlue,
  },
  errImg: {
    filter: theme.filters.error,
  },
});

const MonotoneIconAvatar = ({
  className,
  classes,
  isError,
  ...rest
}) => {
  return (
    <IconAvatar
      classes={{
        root: classNames(classes.root, className),
        img: classNames({ [classes.img]: !isError, [classes.errImg]: isError }),
      }}
      {...rest}
    />
  );
};

MonotoneIconAvatar.defaultProps = {
  className: '',
};

MonotoneIconAvatar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MonotoneIconAvatar);
